<div class="file-preview-container">
  <!-- ---------------------- PREVIEW MODE ----------------------- -->
  @if (usePreview) {
    @switch (getFileType(contentType, fileUrl)) {
      @case (fileType.IMAGE) {
        @if (fileUrl) {
          <img alt="File Preview" class="preview-image" [src]="fileUrl" />
        } @else if (localImagePreview) {
          <img
            alt="File Preview"
            class="preview-image"
            [src]="localImagePreview"
          />
        } @else {
          <div class="file-icon" [innerHTML]="fileIcons.img | safeHtml"></div>
        }
      }

      @case (fileType.PDF) {
        <iframe
          class="pdf-iframe"
          allowfullscreen
          title="PDF Preview"
          [src]="getPdfUrl() | safeUrl"
        >
        </iframe>
      }

      @case (fileType.VIDEO) {
        <video
          controls
          class="video-preview"
          [src]="fileUrl || localVideoPreviewUrl | safeUrl"
        >
          Your browser does not support the video tag.
        </video>
      }

      @case (fileType.AUDIO) {
        <audio controls>
          <source [src]="fileUrl" [type]="contentType" />
          Your browser does not support the audio tag.
        </audio>
      }

      @case (fileType.EXCEL) {
        <iframe
          width="100%"
          height="400px"
          [title]="'Excel Preview'"
          [src]="getOfficeViewerUrl(fileUrl || '') | safeUrl"
        >
        </iframe>
      }

      @case (fileType.PPT) {
        <iframe
          width="100%"
          height="400px"
          [title]="'PowerPoint Preview'"
          [src]="getOfficeViewerUrl(fileUrl || '') | safeUrl"
        >
        </iframe>
      }

      @case (fileType.CSV) {
        <div class="file-icon" [innerHTML]="fileIcons.csv | safeHtml"></div>
      }

      @case (fileType.TEXT) {
        <div class="file-icon" [innerHTML]="fileIcons.text | safeHtml"></div>
      }

      @case (fileType.WORD) {
        <div class="file-icon" [innerHTML]="fileIcons.word | safeHtml"></div>
      }

      @case (fileType.ZIP) {
        <div class="file-icon" [innerHTML]="fileIcons.zip | safeHtml"></div>
      }

      @case (fileType.CODE) {
        <div class="file-icon" [innerHTML]="fileIcons.code | safeHtml"></div>
      }

      @case (fileType.DESIGN) {
        <div class="file-icon" [innerHTML]="fileIcons.design | safeHtml"></div>
      }

      @default {
        <div class="file-icon" [innerHTML]="defaultFileIcon | safeHtml"></div>
      }
    }
  }

  <!-- ---------------------- ICON MODE ----------------------- -->
  @else {
    @switch (getFileType(contentType, fileUrl)) {
      @case (fileType.IMAGE) {
        <div class="file-icon" [innerHTML]="fileIcons.img | safeHtml"></div>
      }

      @case (fileType.PDF) {
        <div class="file-icon" [innerHTML]="fileIcons.pdf | safeHtml"></div>
      }

      @case (fileType.EXCEL) {
        <div class="file-icon" [innerHTML]="fileIcons.excel | safeHtml"></div>
      }

      @case (fileType.CSV) {
        <div class="file-icon" [innerHTML]="fileIcons.csv | safeHtml"></div>
      }

      @case (fileType.TEXT) {
        <div class="file-icon" [innerHTML]="fileIcons.text | safeHtml"></div>
      }

      @case (fileType.WORD) {
        <div class="file-icon" [innerHTML]="fileIcons.word | safeHtml"></div>
      }

      @case (fileType.PPT) {
        <div class="file-icon" [innerHTML]="fileIcons.ppt | safeHtml"></div>
      }

      @case (fileType.VIDEO) {
        <div class="file-icon" [innerHTML]="fileIcons.video | safeHtml"></div>
      }

      @case (fileType.AUDIO) {
        <div class="file-icon" [innerHTML]="fileIcons.audio | safeHtml"></div>
      }

      @case (fileType.ZIP) {
        <div class="file-icon" [innerHTML]="fileIcons.zip | safeHtml"></div>
      }

      @case (fileType.CODE) {
        <div class="file-icon" [innerHTML]="fileIcons.code | safeHtml"></div>
      }

      @case (fileType.DESIGN) {
        <div class="file-icon" [innerHTML]="fileIcons.design | safeHtml"></div>
      }

      @default {
        <div class="file-icon" [innerHTML]="defaultFileIcon | safeHtml"></div>
      }
    }
  }
</div>
